<template>
    <a-drawer :wrapClassName="isDesktopVersion() ? 'drawer-custom-desktop' : 'drawer-custom'" :placement="isDesktopVersion() ? 'right' : 'bottom'"  :width="isDesktopVersion() ? 440 : 'auto'" :height="'89%'"  :closable="false" @close="onClose" :visible="$parent.visibleBottomCart">
           <div class="flex justify-end">
                <a href="javascript:void(0)" @click="$parent.visibleBottomCart = false" class="block hover:bg-gray-200 rounded-full p-1">
                    <svg xmlns='http://www.w3.org/2000/svg' class='fill-current text-gray-800 rounded-full' viewBox='0 0 512 512'  height="32" width="32"><title>Close</title><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M368 368L144 144M368 144L144 368'/></svg>
                </a>
            </div>
            <div class="mt-40 w-full flex flex-col items-center">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-32 h-32 opacity-20"><path d="M2.25 2.25a.75.75 0 000 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 00-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 000-1.5H5.378A2.25 2.25 0 017.5 15h11.218a.75.75 0 00.674-.421 60.358 60.358 0 002.96-7.228.75.75 0 00-.525-.965A60.864 60.864 0 005.68 4.509l-.232-.867A1.875 1.875 0 003.636 2.25H2.25zM3.75 20.25a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM16.5 20.25a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"></path></svg>
                <div class="text-gray-600 text-lg my-10">{{ $root.getKeyWord('empty_cart') || 'Your cart is empty' }}</div>
            </div>  
            <div v-if="pendingOrder" class="w-full mt-auto mb-4">
                <a href="javascript:void(0)"
                    @click="goToPendingOrder"
                    :style="'background-color: ' + $root.hotelColor() + ''"
                    class="w-full flex items-center justify-between !text-white rounded-lg px-3 py-2">
                    <span class="!text-white text-sm sm:text-base leading-snug flex-1 min-w-0 pr-3 break-words">{{ $root.getKeyWord('pending_order_cta') || ('Your last order #' + pendingOrder.id + ' is pending, go to orders?') }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 text-white flex-shrink-0"><path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" /></svg>
                </a>
            </div>
    </a-drawer>    
</template>

<script>
import { eventBus } from '../../../main';

export default {
    name: 'AppBottomCart',

    data() {
        return {
            pendingOrder: null,
        }
    },

    computed: {
        cartVisible() {
            return this.$parent.visibleBottomCart;
        }
    },

    watch: {
        cartVisible(val) {
            if (val) {
                this.fetchPendingOrder();
            }
        }
    },

    created() {
        // Keep the CTA fresh when order state changes elsewhere in the app.
        eventBus.$on('get-orders', () => this.fetchPendingOrder());
    },

    mounted() {
        this.fetchPendingOrder();
    },

    methods: {
        onClose() {
            this.$parent.visibleBottomCart = false;
        },

        goToPendingOrder() {
            this.$parent.visibleBottomCart = false;
            // My-orders is a drawer opened via the event bus, not a route.
            eventBus.$emit('toggle-my-orders');
        },

        getTrackedUuids() {
            const raw = localStorage.getItem('fs_uuids');
            if (!raw || raw === 'undefined') {
                return [];
            }
            try {
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        },

        fetchPendingOrder() {
            const uuids = this.getTrackedUuids();
            if (!uuids.length) {
                this.pendingOrder = null;
                return;
            }

            this.$http.get(process.env.VUE_APP_API_URL + 'hotels/' + this.$root.hotelCode + '/orders/check', {
                params: {
                    order_uuids: uuids,
                }
            }).then(response => {
                // When there are no orders the API returns an empty array,
                // otherwise an object keyed by bucket (draft/pending/queue/histories).
                const data = response.data || {};
                const active = []
                    .concat(Array.isArray(data.draft) ? data.draft : [])
                    .concat(Array.isArray(data.pending) ? data.pending : [])
                    .concat(Array.isArray(data.queue) ? data.queue : []);

                // Show the most recent still-open order as the CTA (completed
                // orders in `histories` are intentionally excluded).
                this.pendingOrder = active.length
                    ? active.reduce((latest, order) => (order.id > latest.id ? order : latest))
                    : null;
            }).catch(() => {
                this.pendingOrder = null;
            });
        }
    }
}
</script>
<style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style>
